
import { Component, Mixins, Prop, } from "vue-property-decorator";
import { WorkflowCommonMixin } from "../../../mixins";
import { ReceptionComment, ReceptionCommentSet } from "../../../../../domain/workflow/reception";
import { ReceptionCommentKinds, ReceptionCommentUnitKinds, ReceptionCommentSortItemKinds } from "../../../../../domain/workflow/kinds";
import { CommentListCommonMixin } from "../mixins";

enum CommentTabKinds {
  Creator, // 記載者用
  Admin, // 管理者用
}

@Component({
  components: {
  }
})

/**
 * コメントテーブルリスト用Mixin
 */
export default class CommentListTableMixin extends Mixins(WorkflowCommonMixin, CommentListCommonMixin) {
  @Prop()
  isWide: boolean;

  @Prop()
  isRegistered: boolean;

  @Prop()
  isDeleted: boolean;

  @Prop()
  commentSet: ReceptionCommentSet;

  @Prop({default: false})
  isReadOnly: boolean;

  data(): any {
    return {
      displayKind: CommentTabKinds.Creator,
      nextMessageSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      commentSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      backMessageSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      conflictCommentSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      restrictCommentSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      contactedInfoSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
      delCommentSortType: ReceptionCommentSortItemKinds.UpdateDateTime,
    };
  }
  displayKind: CommentTabKinds;

  // コメントの並び順を指定するラジオボタンの選択値
  // CommentTable内に持たせるのが正解だが以下の理由からここに持つ.
  // ・記載者用タブと管理者用タブをv-ifで切り替えてるので切り替えるとコンポーネントが破棄されて状態保持できない.
  // ・v-showで切り替えると切替後に垂直方向のスクロールバー表示がおかしくなる問題が出て簡単に解決できない.
  //    →DOMレンダリングがおかしいのでなくelement-uiが間違ったstyleを指定してる模様.
  nextMessageSortType: ReceptionCommentSortItemKinds;
  commentSortType: ReceptionCommentSortItemKinds;
  backMessageSortType: ReceptionCommentSortItemKinds;
  conflictCommentSortType: ReceptionCommentSortItemKinds;
  restrictCommentSortType: ReceptionCommentSortItemKinds;
  contactedInfoSortType: ReceptionCommentSortItemKinds;
  delCommentSortType: ReceptionCommentSortItemKinds;


  get commentTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.Comment);
  }

  get restrictCommentTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.Restrict);
  }

  get nextMessageTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.NextMessage);
  }

  get backMessageTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.BackMessage);
  }

  get contactedInfoTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.ContactedInfo);
  }

  get delCommentTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.Delete);
  }

  get conflictCommentUnitKind(): ReceptionCommentUnitKinds {
    return ReceptionCommentUnitKinds.Multiple;
  }

  // 削除コメントの管理単位
  get delCommentUnitKind(): ReceptionCommentUnitKinds {
    return this.commentSetting ? this.commentSetting.delCommentMode : ReceptionCommentUnitKinds.Multiple;
  }

  // コメント追加が可能か
  get hasCommentPermission(): boolean {
    return this.isRegistered && this.commentSetting && this.commentSetting.isCommentRegisterable;
  }

  // 閲覧制限コメント追加が可能か
  get hasRestrictCommentPermission(): boolean {
    return this.isRegistered && this.commentSetting && this.commentSetting.isRestrictCommentRegisterable && this.isRestrictCommentEnable;
  }

  // 伝達事項追加が可能か
  get hasNextMessagePermission(): boolean {
    return this.isRegistered && this.commentSetting && this.commentSetting.isNextMessageRegisterable;
  }  

  // 連絡済情報追加が可能か
  get hasContactedInfoPermission(): boolean {
    return this.isRegistered && this.commentSetting && this.commentSetting.isContactedCommentRegisterable;
  }

  // 削除コメント追加が可能か
  get hasDelCommentPermission(): boolean {
    return this.isDeleted && this.commentSetting && this.commentSetting.isDelCommentRegisterable;
  }

  get isCreatorTabVisible(): boolean {
    return this.displayKind === CommentTabKinds.Creator;
  }

  get isAdminTabVisible(): boolean {
    return this.displayKind === CommentTabKinds.Admin;
  }

  showCreatorTab(): void {
    this.displayKind = CommentTabKinds.Creator;
  }

  showAdminTab(): void {
    this.displayKind = CommentTabKinds.Admin;
  }

  // 差戻しコメントエリアを表示するか
  get isBackSectionVisible(): boolean {
    return this.backMessages.length > 0;
  }

  // 競合コメントエリアを表示するか
  get isConflictCommentVisible(): boolean {
    return this.conflictComments.length > 0;
  }

  get comments(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.comments : [];
  }

  get restrictComments(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.restrictComments : [];
  }

  get nextMessages(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.nextMessages : [];
  }

  get backMessages(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.backMessages : [];
  }

  get contactedComments(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.contactedComments : [];
  }

  get delComments(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.delComments : [];
  }

  get conflictComments(): ReceptionComment[] {
    return this.commentSet ? this.commentSet.conflictComments : [];
  }

  get isCommentReadOnly(): boolean {
    if (this.isReadOnly) { return true; }
    return this.commentSet ? this.commentSet.isReadOnly : false;
  }

  // --------------------- コメント -------------------------------------
  addComment(): void {
    this.showCommentDialog(ReceptionCommentKinds.Comment, this.commentTitle, null, null, this.commentTitle);
  }

  editComment(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.Comment, this.commentTitle + "編集", this.getComment(row), null, this.commentTitle);
  }

  deleteComment(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.Comment, this.getComment(row));
  }

  private getComment(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.Comment);
  }

  // --------------------- 閲覧制限コメント ------------------------------
  addRestrictComment(): void {
    this.showCommentDialog(ReceptionCommentKinds.Restrict, this.restrictCommentTitle, null, null, this.restrictCommentTitle);
  }

  editRestrictComment(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.Restrict, this.restrictCommentTitle + "編集", this.getRestrictComment(row), null, this.restrictCommentTitle);
  }

  deleteRestrictComment(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.Restrict, this.getRestrictComment(row));
  }

  private getRestrictComment(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.Restrict);
  }

  // --------------------- 伝達事項 --------------------------------------
  addNextMessage(): void {
    this.showCommentDialog(ReceptionCommentKinds.NextMessage, this.nextMessageTitle, null, this.commentSet, this.nextMessageTitle);
  }

  editNextMessage(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.NextMessage, this.nextMessageTitle + "編集", this.getNextMessage(row), this.commentSet, this.nextMessageTitle);
  }

  deleteNextMessage(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.NextMessage, this.getNextMessage(row));
  }

  private getNextMessage(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.NextMessage);
  }

  // --------------------- 差戻(編集のみ) --------------------------------------
  editBackMessage(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.BackMessage, this.backMessageTitle + "編集", this.getBackMessage(row), this.commentSet, this.backMessageTitle);
  }

  private getBackMessage(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.BackMessage);
  }

  // --------------------- 連絡済情報 ------------------------------------
  addContactedInfo(): void {
    this.showCommentDialog(ReceptionCommentKinds.ContactedInfo, this.contactedInfoTitle, null, null, this.contactedInfoTitle);
  }

  editContactedInfo(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.ContactedInfo, this.contactedInfoTitle + "編集", this.getContactedInfo(row), null, this.contactedInfoTitle);
  }

  deleteContactedInfo(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.ContactedInfo, this.getContactedInfo(row));
  }

  private getContactedInfo(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.ContactedInfo);
  }

  // --------------------- 削除コメント ----------------------------------
  addDelComment(): void {
    this.showCommentDialog(ReceptionCommentKinds.Delete, this.delCommentTitle, null, null, this.delCommentTitle);
  }

  editDelComment(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.Delete, this.delCommentTitle + "編集", this.getDelComment(row), null, this.delCommentTitle);
  }

  deleteDelComment(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.Delete, this.getDelComment(row));
  }

  private getDelComment(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.Delete);
  }

  // --------------------- 競合コメント ----------------------------------
  editConflictComment(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.Conflict, this.conflictCommentTitle + "編集", this.getConflictComment(row), null, this.conflictCommentTitle);
  }

  deleteConflictComment(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.Conflict, this.getConflictComment(row));
  }

  private getConflictComment(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.Conflict);
  }

  // --------------------------------------------------------------

  private getCommentCommon(row: ReceptionComment, kind: ReceptionCommentKinds): ReceptionComment {
    if  (!!row && row instanceof ReceptionComment) { return row; }
    
    switch (kind) {
      case ReceptionCommentKinds.Comment:
        return this.comments[0];
      case ReceptionCommentKinds.Restrict:
        return this.restrictComments[0];
      case ReceptionCommentKinds.NextMessage:
        return this.nextMessages[0];
      case ReceptionCommentKinds.BackMessage:
        return this.backMessages[0];
      case ReceptionCommentKinds.ContactedInfo:
        return this.contactedComments[0];
      case ReceptionCommentKinds.Delete:
        return this.delComments[0];
      case ReceptionCommentKinds.Conflict:
        return this.conflictComments[0];
    }

    return null; // ここには到達しないように
  }

  // ------------------- 登録 -----------------------------------------

  async deleteCommentCommon(kind: ReceptionCommentKinds, comment: ReceptionComment): Promise<void> {
    const confirmResult = await this.confirmDeleteComment(kind);
    if (confirmResult == null) { // 登録キャンセルした
      return;
    }

    this.execDeleteComment(kind, comment);
  }

  showCommentDialog(kind: ReceptionCommentKinds, title: string, comment: ReceptionComment, commentSet: ReceptionCommentSet, label: string): void {
    // view側で実装
  }

  async confirmDeleteComment(kind: ReceptionCommentKinds): Promise<number> {
    // view側で実装
    return null;
  }

}

